/**
 * useUpgradeTracking (Iter 73j, erweitert Feb 2026 Sprint 1) — Conversion-Tracking
 * für Upgrade-CTAs. Speichert in localStorage UND POSTet ans Backend (fire-and-forget)
 * für Cross-User-Aggregation im Admin-Insights-Tab.
 *
 * Verwendung:
 *   const track = useUpgradeTracking();
 *   <Button onClick={() => track('click', 'mobile_scan', 'pro_yearly')}>...
 *
 * Backend: POST /api/tracking/upgrade { event, source, target_plan? }
 */
import { useCallback } from 'react';
import api from '@/utils/api';

const STORAGE_KEY = 'ivoliq_upgrade_tracking';

function read() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
  } catch {
    return {};
  }
}

function write(data) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* ignore */
  }
}

export function useUpgradeTracking() {
  return useCallback((event, source, target_plan) => {
    if (!event || !source) return;
    // Local persistence
    const data = read();
    if (!data.counts) data.counts = {};
    if (!data.counts[source]) data.counts[source] = { views: 0, clicks: 0 };
    if (event === 'view') data.counts[source].views += 1;
    else if (event === 'click') data.counts[source].clicks += 1;
    data.last_seen = new Date().toISOString();
    write(data);

    // Backend (fire-and-forget — ignore failures so tracking never blocks UX)
    api.post('/tracking/upgrade', { event, source, target_plan }).catch(() => {});

    // Plausible (falls installiert)
    if (typeof window !== 'undefined' && typeof window.plausible === 'function') {
      try {
        window.plausible(`upgrade_${event}`, { props: { source, target_plan } });
      } catch {
        /* swallow */
      }
    }
  }, []);
}

/** Liest die aktuellen lokalen Counters aus — nur für Debug. */
export function getUpgradeStats() {
  return read();
}

